exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".listMain\n{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.listSideMenuFormat\n{\n    display: inline-block;\n    background-color: rgb(50,50,50);\n    width: 20%;\n    -webkit-box-align: stretch;\n        -ms-flex-align: stretch;\n            align-items: stretch;\n    padding-bottom: 20%;\n}\n\n.listOuterContent\n{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 70%;\n    margin: 0 auto;\n    \n    overflow-wrap: break-word;\n}\n\n.listContent\n{\n    display: block;\n    vertical-align: top;\n    line-height: 19pt;\n    width: 100%;\n}\n\n.listMain\n{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/listVideosPage/listVideosPage.component.css
// module id = ../../../../../src/app/components/listVideosPage/listVideosPage.component.css
// module chunks = main